'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 商品规格+价格设置组件
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _product_spec = require('./product_spec');

var _product_spec2 = _interopRequireDefault(_product_spec);

var _product_price = require('./product_price');

var _product_price2 = _interopRequireDefault(_product_price);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpecPriceInput = _react2.default.createClass({
    displayName: 'SpecPriceInput',
    getInitialState: function getInitialState() {
        var value = this.props.value || {};
        return {
            addedSpecs: value.addedSpecs || [],
            prices: value.prices || []
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({
            addedSpecs: nextProps.value && nextProps.value.addedSpecs,
            prices: nextProps.value && nextProps.value.prices,
            type: nextProps.value && nextProps.value.type
        });
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (JSON.stringify(this.state) === JSON.stringify(nextState)) {
            return false;
        }
        return true;
    },
    onAddSpecItem: function onAddSpecItem() {
        this.setState(function (state, props) {
            var addedSpecs = state.addedSpecs.map(function (x) {
                return _extends({}, x);
            });
            addedSpecs.push({
                name: '',
                values: []
            });
            this.triggerChange({
                addedSpecs: addedSpecs
            });
            return {
                addedSpecs: addedSpecs
            };
        });
    },
    onDelSpecItem: function onDelSpecItem(index) {
        this.setState(function (state, props) {
            var addedSpecs = state.addedSpecs.map(function (x) {
                return _extends({}, x);
            });
            addedSpecs.splice(index, 1);
            this.triggerChange({
                addedSpecs: addedSpecs
            });
            return {
                addedSpecs: addedSpecs
            };
        });
    },
    onChangeSpecValue: function onChangeSpecValue(index, values) {
        this.setState(function (state, props) {
            var addedSpecs = state.addedSpecs.map(function (x) {
                return _extends({}, x);
            });
            addedSpecs[index].values = values;
            this.triggerChange({
                addedSpecs: addedSpecs
            });
            return {
                addedSpecs: addedSpecs
            };
        });
    },
    onSelectSpecName: function onSelectSpecName(index, value) {
        this.setState(function (state, props) {
            var addedSpecs = state.addedSpecs.map(function (x) {
                return _extends({}, x);
            });
            addedSpecs[index].name = value;
            this.triggerChange({
                addedSpecs: addedSpecs
            });
            return {
                addedSpecs: addedSpecs
            };
        });
    },
    onChangePrice: function onChangePrice(index, record) {
        this.setState(function (state, props) {
            var prices = state.prices.map(function (x) {
                return _extends({}, x);
            });
            var keysToOmit = ['code', 'templates', 'weight', 'price'];
            var index = prices.findIndex(function (x) {
                return JSON.stringify((0, _utils.omit)(x, keysToOmit)) === JSON.stringify((0, _utils.omit)(record, keysToOmit));
            });
            if (index >= 0) {
                prices[index] = Object.assign(prices[index], record);
            } else {
                prices.push(record);
            }
            this.triggerChange({
                prices: prices
            });
            return {
                prices: prices
            };
        });
    },
    triggerChange: function triggerChange(changedValue) {
        // Should provide an event to pass value to Form.
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(Object.assign({}, this.state, changedValue));
        }
    },
    render: function render() {
        var _state = this.state,
            addedSpecs = _state.addedSpecs,
            prices = _state.prices;

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_product_spec2.default, {
                addedSpecs: addedSpecs,
                onAddSpecItem: this.onAddSpecItem,
                onDelSpecItem: this.onDelSpecItem,
                onChangeSpecValue: this.onChangeSpecValue,
                onSelectSpecName: this.onSelectSpecName
            }),
            _react2.default.createElement(_product_price2.default, {
                onDelPrice: this.onDelPrice,
                onChangePrice: this.onChangePrice,
                addedSpecs: addedSpecs,
                prices: prices,
                templates: this.props.templates,
                showModal: this.props.showModal,
                params: this.props.params
            })
        );
    }
});

exports.default = SpecPriceInput;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/spec_price_input.js
// module id = 1490
// module chunks = 0